import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { DataRequestWKList } from "../util/DRequestWKList";
import { DataUtil } from "../util/Util";
import { _LOCALDATA_GetGruposHorariosDeAlumno } from "./Alumno";

import { MEscuela } from "../model/MEscuela";
import ICircular = Entidad.ICircular;

const IDREQUEST = Entidad.CTipoRequest.Circular;
const URLSVCCIRCULAR = _APP_CONFIG.URL_RSTV2 + "noticia/";
export const _DICC_NOTICIA: Map<number, ICircular> = new Map();

export function _SvNoticiaObtenerLista(escuelas: MEscuela[]): DataRequestWKList<MEscuela, ICircular> {
    const url = URLSVCCIRCULAR + "ObtenerLista";

    return new DataRequestWKList({
        iterable: escuelas,
        individualRequest: async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(IDREQUEST, IdKinder);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "IdEscuela": IdKinder,
                "Modificacion": currentDateStr
            }
            return () => DataDRequest._Request4List(url, "GET", params, IDREQUEST, IdKinder, { use: true });
        }
    })
}

/** Resultado:
 * * -1: Error
 * * -2: Sin nivel (grado)
 * * -3: No existe o ya fue procesada
 * * -4: Fuera de tiempo, la fecha programada de la noticia es anterior a la fecha actual
 */
export function _SvNoticiaActualizar(circularData: Entidad.ICircular): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV2 + "noticia/ActualizarNoticiaV2"; // "AdminJS/Noticia/ActualizarNoticia";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdNoticia": circularData.IdNoticia,
        "Titulo": circularData.Titulo,
        "Mensaje": circularData.Mensaje,
        // "Grados": circularData.Niveles,
        // "Grupos": circularData.Grupos,
        "Programado": circularData.Programado,
        "ReqAutorizacion": circularData.ReqAutorizacion,
        "Expiracion": circularData.Expira
    }

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: DataDRequest.IRequestResponseBase<undefined>) => {
            resolve({
                Resultado: (result?.Resultado || -100),
                TipoRequest: IDREQUEST,
            })
        })
    })
}

// FIXME Se va a cambiar el servicio ?
export function _SvNoticiaEliminar(idNoticia: number): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV1 + "Noticia/EliminarNoticia";
    const params = {
        IdNoticia: idNoticia,
        IdUsuario: DataUtil._Usuario.IdUsuario
    }

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: number) => {
            resolve({
                Resultado: (result || -100),
                TipoRequest: IDREQUEST,
            });
        })
    })
}

type PromiseCircularInfoArchivo = Promise<DataDRequest.IRequestResponseA<Entidad.IInfoArchivo[]>>;
interface ICircularGetInfoArchivoRecord {
    Datos: Entidad.IInfoArchivo[];
    Promise: PromiseCircularInfoArchivo;
}
/** Map<IdArchivo, IInfoArchivo> */
const circularGetInfoArchivoRecords = new Map<number, ICircularGetInfoArchivoRecord>();
export async function _SvNoticiaObtenerInfoArchivos(idNoticia: number): PromiseCircularInfoArchivo {
    const url = _APP_CONFIG.URL_RSTV2 + "noticia/ObtenerInfoArchivos";
    const params = { "IdNoticia": idNoticia };

    let info = circularGetInfoArchivoRecords.get(idNoticia);
    if (info?.Promise) {
        // console.warn("CInfoFile -> Reutilizando promesa", idNoticia);
        return info.Promise;
    }
    else if (info?.Datos) {
        // console.warn("CInfoFile -> dato local", idNoticia);
        return {
            Resultado: 1,
            Datos: info.Datos,
            TipoRequest: IDREQUEST,
        }
    }
    else if (!info) {
        info = {
            Datos: null,
            Promise: null,
        }
        circularGetInfoArchivoRecords.set(idNoticia, info);
    }
    // console.warn("CInfoFile -> Nueva promesa", idNoticia);
    const res = DataDRequest._Request5<Entidad.IInfoArchivo[]>(url, "GET", params, IDREQUEST)
        .then(res => {
            res.Datos = res.Datos || [];
            if (res.Resultado > 0) {
                info.Datos = res.Datos;
            }
            return res;
        })
        .catch(() => ({
            Resultado: -100,
        }))
        .finally(() => {
            info.Promise = null;
        });
    info.Promise = res
    return res;
}

/** @deprecated // FIXME */
export async function _SvNoticiaEliminarArchivo<TParam>(params: TParam): Promise<DataDRequest.IResultadoPeticion<TParam>> {
    var url = _APP_CONFIG.URL_RSTV2 + "Noticia/EliminarArchivoNoticia";

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: any) => {

            let item: DataDRequest.IResultadoPeticion<TParam> = { Resultado: -1, Data: params };
            item.TipoRequest = IDREQUEST;

            resolve(item as any);
        })
    })
}

type ISendCircularItem = Pick<Entidad.ICircular, "Titulo" | "Mensaje" | "Programado" | "ReqAutorizacion" | "Grupos" | "Niveles" | "Expira"> &
{
    IdEscuela: number;
    Archivo: File;
}

export interface IMapSendCincularItems {
    ByGrupos: ISendCircularItem & {

    },
    ByAlumnos: ISendCircularItem & {
        IdAlumnos: number[];
    }
}
export async function _SvNoticiaNueva<KOrigin extends keyof IMapSendCincularItems>(origin: KOrigin, dato: IMapSendCincularItems[KOrigin]): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV2 + "noticia/NuevaNoticia";
    let statusData = 1;

    const formData = new FormData();

    if (origin == "ByGrupos") {
        let datoGrid: IMapSendCincularItems["ByGrupos"] = dato as any;
        if (datoGrid.Niveles?.length > 0 && datoGrid.Grupos?.length > 0) {
            formData.append("Grados", datoGrid.Niveles.toString());
            formData.append("Grupos", datoGrid.Grupos.toString());
        } else {
            statusData = -2;
        }
    }
    else if (origin == "ByAlumnos") {
        let datoPAlumno: IMapSendCincularItems["ByAlumnos"] = dato as any;
        if (datoPAlumno.IdAlumnos && datoPAlumno.IdAlumnos.length) {
            datoPAlumno.Grupos = []
            datoPAlumno.Niveles = [] // Grados

            datoPAlumno.IdAlumnos.forEach(idAlumno => {
                let horariosGruposArray = Array.from(_LOCALDATA_GetGruposHorariosDeAlumno(idAlumno, datoPAlumno.IdEscuela).values());
                let grupo = horariosGruposArray.find(d => (d.EsPrincipal))
                if (!grupo) grupo = horariosGruposArray[0];
                if (grupo && grupo.IdGrado) {
                    datoPAlumno.Grupos.push(grupo.IdGrupo);
                    datoPAlumno.Niveles.push(grupo.IdGrado);
                } else {
                    statusData = -1;
                }
            })

            formData.append("Grados", datoPAlumno.Niveles.toString());
            formData.append("Grupos", datoPAlumno.Grupos.toString());
            formData.append("Alumnos", datoPAlumno.IdAlumnos.toString());
        } else {
            statusData = -1;
        }
    }

    if (statusData < 0) {
        return {
            Resultado: statusData,
            TipoRequest: IDREQUEST
        }
    }

    formData.append("IdOrganizacion", DataUtil._Usuario.IdOrganizacion.toString());
    formData.append("IdUsuario", DataUtil._Usuario.IdUsuario.toString());

    formData.append("IdKinder", dato.IdEscuela.toString());
    formData.append("Titulo", dato.Titulo);
    formData.append("Mensaje", dato.Mensaje);
    formData.append("Programado", dato.Programado || "null");
    formData.append("ReqAutorizacion", dato.ReqAutorizacion as any || "false");
    if (dato.Expira != null)
        formData.append("Expiracion", dato.Expira)

    if (dato.Archivo) {
        formData.append("Archivo", dato.Archivo, dato.Archivo.name);
    }
    // else {
    //     formData.append("Archivo", "");
    // }

    return DataDRequest._XMLHttpRequestFormHandler(url, "POST", formData, IDREQUEST);
}

type CircularAutorizacionesRes = { IdNoticia: number; Grupos: Entidad.ICircularGrupoAutorizaciones[]; };
type PromiseCircularGrupoAutorizaciones = Promise<DataDRequest.IRequestResponseA<Entidad.ICircularGrupoAutorizaciones[]>>;
interface ICircularGetInfoRecord {
    Datos: Entidad.ICircularGrupoAutorizaciones[];
    DtLastRequest: string;
    Promise: PromiseCircularGrupoAutorizaciones;
}
let circularGetInfoRecords = new Map<number, ICircularGetInfoRecord>();
/**
 * Si no es una peticion forzada, las Autorizaciones se consultan a partir de 2 mins desde la ultima consulta. */
export async function _SvNoticiaObtenerInfoAutorizacion(idCircular: number, force: boolean): PromiseCircularGrupoAutorizaciones {
    const url = _APP_CONFIG.URL_RSTV2 + "noticia/ObtenerInfoAutorizacionV2"; // ".../ObtenerInfoAutorizacion";
    const params = {
        "IdNoticia": idCircular,
    }
    const minMaxReq = 1;
    const minClearMap = 15;
    let lastR: ICircularGetInfoRecord = circularGetInfoRecords.get(idCircular);

    if (!force && lastR && lastR.DtLastRequest && !lastR.Promise) {
        // Verifica que hayan pasado un n mins para consultar
        let dtLastModificacion = new Date(lastR.DtLastRequest);
        let dtAuxRef = new Date();
        dtAuxRef.setMinutes(dtAuxRef.getMinutes() - minMaxReq);
        if (dtAuxRef < dtLastModificacion) {
            // console.warn("Circ -> Datos locales no ha pasado", minMaxReq, "mins", idCircular);
            return {
                Resultado: 1,
                TipoRequest: IDREQUEST,
                Datos: lastR.Datos || [],
            };
        }
        else {
            dtAuxRef.setMinutes(dtAuxRef.getMinutes() - minClearMap);
            if (dtAuxRef > dtLastModificacion) {
                // console.warn("Circ -> Limpiando Map", idCircular);
                circularGetInfoRecords.clear();
                circularGetInfoRecords.set(idCircular, lastR);
            }
        }
    }
    else if (!lastR) {
        lastR = {
            Datos: null,
            DtLastRequest: null,
            Promise: null,
        }
        circularGetInfoRecords.set(idCircular, lastR);
    }

    if (lastR.Promise) {
        // console.warn("Circ -> Reutilizando promesa", idCircular);
        return lastR.Promise;
    }

    const res = DataDRequest._Request5<CircularAutorizacionesRes>(url, "GET", params, IDREQUEST)
        .then(res => {
            if (res.Resultado > 0) {
                lastR.DtLastRequest = new Date().toISOString();
                lastR.Datos = res.Datos.Grupos || [];
            }
            // console.warn("Circ -> Promesa cumplida", idCircular);
            return {
                ...res,
                ...{
                    Datos: lastR.Datos,
                }
            };
        })
        .catch(res => ({
            Resultado: -100,
        }))
        .finally(() => {
            lastR.Promise = null;
        });
    lastR.Promise = res;
    // console.warn("Circ -> Nueva promesa", idCircular);
    return res;
}

export function _SvNoticiaObtenerDetalle(idCircular: number, idsGrupos: number[]) {
    const url = _APP_CONFIG.URL_RSTV2 + "noticia/ObtenerDetalle";
    const params = {
        "IdNoticia": idCircular,
        "Grupos": idsGrupos.toString(),
    }
    type TResponse = {
        EsAutorizado: boolean;
        Estado: number;
        IdAlumno: number;
        IdGrupo: number;
        IdNoticia: number;
        IdTutorAutorizacion: number;
        Tutores: number[];
    }
    return DataDRequest._Request5<TResponse[]>(url, "GET", params, IDREQUEST);
}

export function _SvNoticiaGetUrlObtenerArchivo(idArchivo: number, tamanio: 1 | 2 | 3) {
    // if (tamanio == 2 || tamanio == 3) {
    return `${_APP_CONFIG.URL_RSTV2}noticia/ObtenerArchivo?IdArchivo=${idArchivo}&Tamanio=${tamanio}`;
    // } else {
    //     return `${Data.Util._GLOBAL_CONF.URL_RSTV2}noticia/ObtenerArchivo?IdArchivo=${idArchivo}`;
    // }
}
